<template>
  <row class="align-items-center">
    Show:
    <button
        class="ml-2 btn btn-select compress dropdown-toggle input-color arrow"
        @click.stop="openContextMenu"
    >
      {{ filterButtonText }}
    </button>

    <context-menu
        ref="contextMenu"
        :state="modalStateFor(vueModalID.filterPermissionPermitteesMenu)"
        :index="vueModalID.filterPermissionPermitteesMenu"
        fixed
        @close="closeContextMenu"
    >
      <ul class="p-3 scroll-area" tabindex="-1" style="max-height: 221px;">
        <li>
          <input id="select_all" type="checkbox" @input="toggleAll" :checked="allChecked">
          <label for="select_all">All Groups and Users</label>
        </li>

        <li v-for="permittee in selectedObjectModel.permissionPermitteesArray" :key="permittee.client_id">
          <input
              type="checkbox"
              :id="permittee.client_id"
              @input="toggleFilterPermittee(permittee.client_id)"
              :checked="permitteeChecked(permittee.client_id)"
          >
          <label :for="permittee.client_id">{{ permittee.display }}</label>
        </li>
      </ul>
    </context-menu>
  </row>
</template>

<script lang="ts">
import Vue from 'vue';
import permissionTablePermitteesMixin from "../mixins/permission-table-permittees-mixin";
import storeMapper from "~/mixins/storeMappers/storeMapper";
import ContextMenu from '~/components/contextMenu.vue'

const objectModelStoreMixin = storeMapper('objectModelStore', {
  mutations: [
    'toggleAllFilteredPermissionPermittees',
    'toggleFilterPermissionPermittee',
  ],
});

export default Vue.extend({
  mixins: [
    permissionTablePermitteesMixin,
    objectModelStoreMixin,
  ],
  components: {
    ContextMenu,
  },
  computed: {
    filterButtonText(): string {
      if (this.allChecked) {
        return 'All Groups and Users';
      } else {
        const selected = this.validSelectedCount;
        const total = this.selectedObjectModel.permissionPermitteesArray.length;
        return `${selected}/${total} Selected`;
      }
    },
    validSelectedCount(): number {
      // filter out deleted permittees, which are kept in clientIds array to allow undo/redo to add them back to the table filters
      const permitteeClientIds = this.selectedObjectModel.permissionPermitteesArray.map(permittee => permittee.client_id);
      return this.filterPermissionPermitteeClientIds.filter(clientId => permitteeClientIds.includes(clientId)).length;
    },
    allChecked(): boolean {
      return this.selectedObjectModel.permissionPermitteesArray.every(permittee => this.filterPermissionPermitteeClientIds.includes(permittee.client_id));
    },
  },
  methods: {
    openContextMenu(event): void {
      this.showModal(this.vueModalID.filterPermissionPermitteesMenu);
      this.$nextTick(() => this.$refs.contextMenu.open(event));
    },
    closeContextMenu(): void {
      this.hideModal(this.vueModalID.filterPermissionPermitteesMenu);
    },
    toggleAll(): void {
      this.toggleAllFilteredPermissionPermittees(!this.allChecked);
    },
    toggleFilterPermittee(permitteeClientId: string): void {
      this.toggleFilterPermissionPermittee(permitteeClientId);
    },
    permitteeChecked(permitteeClientId: string): boolean {
      return this.filterPermissionPermitteeClientIds.includes(permitteeClientId);
    },
  },
});
</script>